export default abstract class TopicsSliderItem {
    isActive = ko.observable(false);
    isSelected = ko.observable(false);
    isHighlighted = ko.observable(false);

    constructor() { }
}